import {
  GET_PENGURUS_OVERVIEW,
  GET_PENGURUS_OVERVIEW_SUCCESS,
  GET_PENGURUS_OVERVIEW_FAIL,
    GET_PENGURUS_PROVINSI,
    GET_PENGURUS_PROVINSI_SUCCESS,
    GET_PENGURUS_PROVINSI_FAIL,
    GET_PENGURUS_KABKOT,
    GET_PENGURUS_KABKOT_SUCCESS,
    GET_PENGURUS_KABKOT_FAIL,
    GET_PENGURUS_KECAMATAN,
    GET_PENGURUS_KECAMATAN_SUCCESS,
    GET_PENGURUS_KECAMATAN_FAIL,
  } from "./actionTypes";
  import { API } from "../../API/api";
  
  // get exco table
  export const getPengurusProvinsi = (order_type,order_by,search,pemenuhan_kabkot,pemenuhan_pengurus_perempuan) => (dispatch) => {
    dispatch({
      type: GET_PENGURUS_PROVINSI,
    });
  
    const request = API.getPengurusProvinsi(order_type,order_by,search,pemenuhan_kabkot,pemenuhan_pengurus_perempuan);
    return request.then(
      (response) => dispatch(getPengurusProvinsiSuccess(response.data)),
      (err) => dispatch(getPengurusProvinsiFail(err))
    );
  };
  
  export const getPengurusProvinsiSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_PENGURUS_PROVINSI_SUCCESS,
      payload: data,
    });
  };
  
  export const getPengurusProvinsiFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_PENGURUS_PROVINSI_FAIL,
      payload: data,
    });
  };

  export const getPengurusKabkot = (order_type,order_by,search,id_provinsi,pemenuhan_kecamatan,pemenuhan_pengurus_perempuan) => (dispatch) => {
    dispatch({
      type: GET_PENGURUS_KABKOT,
    });
  
    const request = API.getPengurusKabkot(order_type,order_by,search,id_provinsi,pemenuhan_kecamatan,pemenuhan_pengurus_perempuan);
    return request.then(
      (response) => dispatch(getPengurusKabkotSuccess(response.data)),
      (err) => dispatch(getPengurusKabkotFail(err))
    );
  };
  
  export const getPengurusKabkotSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_PENGURUS_KABKOT_SUCCESS,
      payload: data,
    });
  };
  
  export const getPengurusKabkotFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_PENGURUS_KABKOT_FAIL,
      payload: data,
    });
  };

  export const getPengurusKecamatan = (order_type,order_by,search,id_kabkot,pemenuhan_pengurus_perempuan) => (dispatch) => {
    dispatch({
      type: GET_PENGURUS_KECAMATAN,
    });
  
    const request = API.getPengurusKecamatan(order_type,order_by,search,id_kabkot,pemenuhan_pengurus_perempuan);
    return request.then(
      (response) => dispatch(getPengurusKecamatanSuccess(response.data)),
      (err) => dispatch(getPengurusKecamatanFail(err))
    );
  };
  
  export const getPengurusKecamatanSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_PENGURUS_KECAMATAN_SUCCESS,
      payload: data,
    });
  };
  
  export const getPengurusKecamatanFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_PENGURUS_KECAMATAN_FAIL,
      payload: data,
    });
  };

  export const getPengurusOverview = (id_tingkat_exco,id_daerah) => (dispatch) => {
    dispatch({
      type: GET_PENGURUS_OVERVIEW,
    });
  
    const request = API.getOverviewPengurus(id_tingkat_exco,id_daerah);
    return request.then(
      (response) => dispatch(getPengurusOverviewSuccess(response.data)),
      (err) => dispatch(getPengurusOverviewFail(err))
    );
  };
  
  export const getPengurusOverviewSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_PENGURUS_OVERVIEW_SUCCESS,
      payload: data,
    });
  };
  
  export const getPengurusOverviewFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_PENGURUS_OVERVIEW_FAIL,
      payload: data,
    });
  };

  